/**
 * Format: Video
 * -----------------------------------------------------------------------------
 * Formats Shopify storefront API media responses.
 *
 */
import { formatImage } from '~/format/format-image';
import { decodeApiId } from '~/helpers/graphql';

/**
 * Format video.
 * - https://shopify.dev/docs/api/storefront/2024-01/interfaces/Media
 * @param {Object} response - GraphQL response.
 * @returns {Array}
 */
export function formatVideo(response) {
  const formattedMedia = {
    alt: response.alt,
    id: decodeApiId(response.id) ?? false,
    mediaType: response.mediaType.toLowerCase(),
  };

  /**
   * Match variant to media if it exists.
   */
  const formattedImageObject = formatImage(response.previewImage);

  if (formattedMedia.mediaType === 'video') {
    formattedMedia.previewImage = formattedImageObject;

    formattedMedia.sources = response.sources.map((source) => {
      return {
        format: source.format,
        height: source.height,
        mimeType: source.mimeType,
        url: source.url,
        width: source.width,
      };
    });
  }

  return formattedMedia;
}
